import React, { useState } from "react";
import { ProcessWrapper, ProgressBar, ProgressBarIndicator } from "../styled";
import Contact from "../../components/contact/contact";
import Question from "../../components/question";
import { ReactComponent as HealthKit } from "../../assets/img/svg/confiansa_la paz.svg";
import { ReactComponent as HandsCoin } from "../../assets/img/svg/confiansa_manosmoneda.svg";

export default function Family({
  finishProcess,
  setRecommendation,
  startOver,
  setContact,
  setAssuranceUrl,
  contact,
  specificStep,
  secondaryStep,
}) {
  const [step, setStep] = useState(
    secondaryStep !== undefined ? secondaryStep : 0
  );

  const nextStep = () => {
    setStep(step + 1);
  };

  const goToStep = (newStep) => {
    setStep(newStep);
  };

  return (
    <ProcessWrapper>
      <ProgressBar>
        <ProgressBarIndicator progressWidth={(100 * (step + 1)) / 4} />
      </ProgressBar>

      {step === 0 && (
        <Contact
          nextStep={nextStep}
          setContact={setContact}
          contact={contact}
        />
      )}
      {step === 1 && (
        <Question
          goToStep={() => goToStep(0)}
          text="¿Qué tipo de protección buscas?"
          icon={<HealthKit fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Respaldo económico por fallecimiento",
              action: () => setStep(2),
            },
            {
              label: "Por enfermedad o accidente",
              action: () => {
                specificStep("health", 2);
              },
            },
          ]}
        />
      )}
      {step === 2 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Qué cobertura necesitas?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Menor a Q200,000",
              action: () => {
                setRecommendation({
                  title: "Seguro de Vida todo Riesgo",
                  phrase1: "Te recomendamos Seguro de Vida Todo Riesgo",
                  phrase2: "",
                });
                finishProcess();
              },
            },
            {
              label: "Mayor a $100,000",
              action: () => {
                setRecommendation({
                  title: "Plan de vida 360",
                  phrase1: "¡Te recomendamos Seguro Plan de vida 360!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/salud-360/");
                finishProcess();
              },
            },
          ]}
        />
      )}
    </ProcessWrapper>
  );
}
